import React from 'react';
import { useTranslation } from 'react-i18next';

import FormInput from 'shared/components/forms/FormInput';

/**
 * Coerce anything the partner types or pastes into an Israeli mobile number.
 * The first two digits are pinned to `05`: a keystroke that would break the
 * prefix is dropped rather than shown and rejected later by the validator.
 */
export const normalizeMobile = (raw: string): string => {
  let digits = raw.replace(/\D/g, '');
  if (digits.startsWith('972')) digits = `0${digits.slice(3)}`;
  if (digits.startsWith('5')) digits = `0${digits}`;

  let out = '';
  for (const ch of digits) {
    if (out.length === 0 && ch !== '0') continue;
    if (out.length === 1 && ch !== '5') continue;
    out += ch;
    if (out.length === 10) break;
  }
  return out;
};

interface FormPhoneInputProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  required?: boolean;
  /** Overrides the default `05XXXXXXXX` hint. */
  hint?: string;
  name?: string;
  id?: string;
  disabled?: boolean;
}

const FormPhoneInput: React.FC<FormPhoneInputProps> = ({
  label,
  value,
  onChange,
  error,
  required,
  hint,
  name,
  id,
  disabled,
}) => {
  const { t } = useTranslation();

  return (
    <FormInput
      label={label}
      name={name}
      id={id}
      required={required}
      error={error}
      hint={hint ?? (t('businessInfo.phoneNumberHint') as string)}
      disabled={disabled}
      type="tel"
      inputMode="numeric"
      autoComplete="tel"
      maxLength={10}
      dir="ltr"
      className="text-start"
      placeholder="05XXXXXXXX"
      value={value}
      onChange={(e) => onChange(normalizeMobile(e.target.value))}
    />
  );
};

export default FormPhoneInput;
